import { encodeParams, getUser, reviveDate } from '@/utils';
import { apiPath, apiRootUrl, platformApiRootUrl } from '@/utils/config';
import ky from 'ky';
import { ajax } from 'rxjs/ajax';

export const test = ky.create({
  prefix: 'http://localhost:4000',
});

export const police = ky.create({
  prefix: 'https://data.police.uk/api',
});

export function fromAjax(path, { method = 'GET', body, headers, params }) {
  const encodedParams = encodeParams(params);
  return ajax({
    url: `${apiRootUrl}${apiPath}${path}${encodedParams ? `?${encodedParams}` : ''}`,
    method: method,
    body: body ? JSON.stringify(body) : undefined,
    headers,
  });
}

export const api = ky.create({
  prefix: `${apiRootUrl}${apiPath}`,
  timeout: false,
  hooks: {
    beforeRequest: [
      ({ request }) => {
        const user = getUser();

        if (user?.access_token) {
          request.headers.set('authorization', `Bearer ${user?.access_token}`);
        }
      },
    ],
  },
  parseJson: (json) =>
    json === 'Unauthorized' ? json : JSON.parse(json, reviveDate),
});

export const platformApi = platformApiRootUrl
  ? ky.create({
      prefix: platformApiRootUrl,
      timeout: false,
      hooks: {
        beforeRequest: [
          async ({ request }) => {
            const user = getUser();
            request.headers.set(
              'authorization',
              `Bearer ${user?.access_token}`,
            );
          },
        ],
      },
      parseJson: (json) => JSON.parse(json, reviveDate),
    })
  : null;
